import { render, staticRenderFns } from "./ModalLogsAlteracaoTipoUsuario.vue?vue&type=template&id=5c00aa14"
import script from "./ModalLogsAlteracaoTipoUsuario.vue?vue&type=script&lang=ts"
export * from "./ModalLogsAlteracaoTipoUsuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports